import { PermissionType } from "./common.constants";

export const USER_MANAGEMENTS_LIST = "USER_MANAGEMENTS_LIST";
export const USER_MANAGEMENTS_CREATE = "USER_MANAGEMENTS_CREATE";

export const PARTNER = "Partner";
export const MERCHANT = "Merchant";
export const ADMIN = "Admin";
export const SUPER_ADMIN = "Super Admin";

export const USER_MANAGEMENT_TITLE_DELETE_CONFIRM = "Delete Confirmation";
export const REFUND_TRANSACTION = "Refund Transaction";
export const CANCEL_TRANSACTION = "Cancel Transaction";
export const VIEW_CARD = "View Card";


// export const VALUE_ADMIN_ROLE = 2;
// export const VALUE_PARTNER_ROLE = 3;
// export const VALUE_MERCHANT_ROLE = 4;

export const USERS_TYPE_OPTIONS = [
  { value: ADMIN, label: ADMIN },
  { value: MERCHANT, label: MERCHANT },
  { value: PARTNER, label: PARTNER },
  { value: SUPER_ADMIN, label: SUPER_ADMIN },
];

export const VALUE_PERMISSIONS_TYPE_API_CONNECTION = PermissionType.apiConnection;
export const VALUE_PERMISSIONS_TYPE_VIRTUAL_TERMINAL = PermissionType.virtualTerminal;

export const PERMISSIONS_TYPE = [
  { value: VALUE_PERMISSIONS_TYPE_API_CONNECTION, label: "API Connection" },
  { value: PermissionType.reportTransactions, label: "Transaction Report", userType: [PARTNER,MERCHANT], child: [
    { userType: [PARTNER], name: "permission_transaction", value: PermissionType.refundTransaction, label: REFUND_TRANSACTION },
    { userType: [PARTNER], name: "permission_transaction", value: PermissionType.cancelTransaction, label: CANCEL_TRANSACTION }
  ] },
  { value: PermissionType.merchantSettings, label: "Merchant Settings" },
  { value: PermissionType.reportDisbursements, label: "Payout Report" },
  { value: PermissionType.merchantNotifications, label: "Notification Settings" },
  { value: PermissionType.reportAutoCharge, label: "Auto Charge Report" },
  { value: PermissionType.chargebackReport, label: "Chargeback Report" },
  { value: PermissionType.vaultService, label: "Vault Management", userType: [MERCHANT], child: { userType: [MERCHANT], name: "permission_vault", value: PermissionType.viewCard, label: VIEW_CARD } },
  { value: PermissionType.reportReceivables, label: "Receivables Report"},
  // { value: VALUE_PERMISSIONS_TYPE_VIRTUAL_TERMINAL, label: "Virtual Terminal" },
];

export const PERMISSION_TYPE_ADMIN = [
  { value: PermissionType.merchantAuditLogs, label: "Audit Log" },
  { value: PermissionType.adminUsers, label: "User Management" },
  { value: PermissionType.adminPartners, label: "Partner Management" },
  { value: PermissionType.adminMerchants, label: "Merchant Management" },
  { value: PermissionType.adminFraudDetectionSetting, label: "Fraud Detection Setting" },
  { value: PermissionType.adminSurchargeBanSetting, label: "Surcharge Ban Setting" },
  { value: PermissionType.adminSystemLog, label: "System Logs" },
];

export const USER_OPTION_DATA_TYPE = [
  { value: "created_at", label: "Creation Date" },
  { value: "last_login", label: "Last Login" },
];

export const USER_OPTION_STATUS = [
  { value: String(1), label: "Activated" },
  { value: String(0), label: "Deactivated" },
]
